import Task2 from './Task2';

export default Task2;